<div class="d-flex flex-column h-100">
	<app-mailbox-breadcrumb class="flex-shrink-0"></app-mailbox-breadcrumb>
	
	@if (navbar.userAccess?.Mailbox=='Full' || navbar.userAccess?.Mailbox=='Readonly') {
	<div class="d-flex flex-nowrap w-100 flex-grow-1 overflow-hidden">
		<!-- Sidebar -->
		<div class="modern-sidebar d-flex flex-column py-3 flex-shrink-0">
			<!-- Compose Button -->
			@if (!mailboxReadonly && navbar.userAccess?.Mailbox=='Full') {
			<div class="mb-4 w-100 px-3">
				<a [routerLink]="['/app/mailbox/compose']" class="btn btn-compose w-100 rounded-pill shadow-sm d-flex align-items-center justify-content-center py-2 text-decoration-none" matTooltip="Compose">
					<fa-icon [icon]="['fas', 'envelope-open']" class="me-2 nav-icon"></fa-icon>
					<span class="fw-semibold">New</span>
				</a>
			</div>
			}
			
			<!-- Navigation Menu -->
			<ul class="nav-menu list-unstyled w-100 m-0 p-0 d-flex flex-column gap-2 px-3">
				<li class="nav-item">
					<a [routerLink]="['/app/mailbox/folder/unlinked']" [routerLinkActive]="['active']" class="nav-link rounded-4 d-flex align-items-center py-2 px-3 position-relative text-decoration-none">
						<fa-icon [icon]="['fas', 'unlink']" class="nav-icon me-3"></fa-icon>
						<span class="nav-text m-0">Unlinked</span>
						<span class="position-absolute top-50 end-0 translate-middle-y me-2 badge rounded-pill bg-unlinked">
							{{unlinkedCnt || 0}}
						</span>
					</a>
				</li>
				<li class="nav-item">
					<a [routerLink]="['/app/mailbox/folder/draft']" [routerLinkActive]="['active']" class="nav-link rounded-4 d-flex align-items-center py-2 px-3 text-decoration-none">
						<fa-icon [icon]="['fas', 'edit']" class="nav-icon me-3"></fa-icon>
						<span class="nav-text m-0">Draft</span>
					</a>
				</li>
				<li class="nav-item">
					<a [routerLink]="['/app/mailbox/folder/outgoing']" [routerLinkActive]="['active']" class="nav-link rounded-4 d-flex align-items-center py-2 px-3 text-decoration-none">
						<fa-icon [icon]="['fas', 'paper-plane']" class="nav-icon me-3"></fa-icon>
						<span class="nav-text m-0">Sent</span>
					</a>
				</li>
				<li class="nav-item">
					<a [routerLink]="['/app/mailbox/folder/spam']" [routerLinkActive]="['active']" class="nav-link rounded-4 d-flex align-items-center py-2 px-3 text-decoration-none">
						<fa-icon [icon]="['fas', 'exclamation-triangle']" class="nav-icon me-3"></fa-icon>
						<span class="nav-text m-0">Spam</span>
					</a>
				</li>
			</ul>
		</div>

		<!-- Main Content Area -->
		<div class="flex-grow-1 position-relative bg-light h-100 overflow-hidden" [@routeAnimations]="prepareRoute(o)">
			<router-outlet #o="outlet"></router-outlet>
		</div>
	</div>
	} @else {
	<div class="d-flex h-100 justify-content-center align-items-center bg-light flex-grow-1">
		<div class="text-center text-muted">
			<fa-icon [icon]="['fas', 'lock']" size="3x" class="mb-3 text-light opacity-50"></fa-icon>
			<h4 class="fw-normal">You don't have access to this section.</h4>
		</div>
	</div>
	}
</div>